/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { debounce } from 'debounce'
import SimpleModal from '@modules/core/components/modal/simpleModal'
import { useTranslation } from 'react-i18next'
import Consultations from '../../../Services/Consultations'
import CustomPagination from '../../tableComponents/Pagination'
import { fetchRelationList } from './actions'
import { defaultFilters } from './constants'
import { FilterBarRelations } from './templates'
import RelationsTable from './Relations.Table'
import styled, { css } from 'styled-components'
const AVAILABLE = 'available'

export const RelationsModal = ({ professionalHash, addToRelationList, doFetchList, closeModal, setError }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState([])
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState(defaultFilters)
  const [page, setPage] = useState(null)
  const [lastPage, setLastPage] = useState(null)
  const fetchParams = {
    page,
    setPage,
    setLastPage,
    professionalHash,
    kind: AVAILABLE,
    setData,
    setLoading,
    setError,
    extraFilters: filters,
  }
  const debounceFetch = debounce(() => fetchRelationList(fetchParams), 350, false)

  const makeRelation = async () => {
    try {
      await Consultations.relations.setRelation(professionalHash, { customer_hashes: selected })
      setSelected([])
      addToRelationList()
    } catch (e) {
      console.log(e)
    }
  }

  const toggleSelected = (hash) => {
    if (selected.includes(hash)) {
      setSelected(selected.filter((el) => el !== hash))
    } else {
      setSelected([...selected, hash])
    }
  }

  const toggleAll = (e) => {
    let hashesRelated = data.map((el) => el.hash)
    if (e.target.checked) {
      setSelected([...selected, ...hashesRelated])
    } else {
      setSelected(selected.filter((el) => !hashesRelated.includes(el)))
    }
  }

  const handleChangePage = (page) => {
    setPage(page)
    fetchRelationList({ ...fetchParams, page })
  }

  useEffect(() => {
    fetchRelationList(fetchParams)
  }, [])

  useEffect(() => {
    debounceFetch()
  }, [filters.search])

  return (
    <SimpleModal
      title={t('addRelations')}
      hideModal={closeModal}
      loading={loading}
      template={
        <ModalTemplate>
          <FilterBarRelations
            t={t}
            setPage={setPage}
            doFetchList={doFetchList}
            filters={filters}
            setFilters={setFilters}
          />
          {!!data.length && !loading && (
            <>
              <Label>{t('userAvailableProfessional')}</Label>
              <CustomTable>
                <RelationsTable
                  customers={data}
                  selectedCustomers={selected}
                  select={toggleSelected}
                  selectAll={toggleAll}
                  scrollable={true}
                />
              </CustomTable>
            </>
          )}
        </ModalTemplate>
      }
      footer={
        <Footer>
          <CustomPagination onClickItem={handleChangePage} activePage={page} totalPages={lastPage} maxButtons={7} />
          <Toolbar>
            <Button danger onClick={closeModal}>
              {t('Cancelar')}
            </Button>
            <Button onClick={makeRelation} disabled={selected.length === 0}>
              {t('Relacionar')}
            </Button>
          </Toolbar>
        </Footer>
      }
    />
  )
}

const Label = styled.div`
  text-align: center;
  padding: 10px 0;
  font-size: 15px;
  background: #e4f8ff;
`
const CustomTable = styled.div`
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  & > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`
const Footer = styled.div`
  width: 100%;
`
const Toolbar = styled.div`
  display: flex;
  justify-items: center;
  padding: 10px;
`
const Button = styled.button.attrs({
  className: 'btn btn-primary',
})`
  ${(props) =>
    props.danger &&
    css`
      background: #d9534f;
    `}
  margin: 3px;
  width: auto;
  max-width: fit-content;
`
const ModalTemplate = styled.div`
  .md-select-basic {
    margin: 3px !important;
  }
  height: 100%;
  display: flex;
  & > {
    height: 100%;
  }
  flex-direction: column;
  .filter-bar {
    padding: 9px 0px;
  }
  .paginator {
    height: auto;
    padding: 10px 10px 6px 10px;
    .pagination {
      margin: 0;
    }
  }
`
